//导入两个文件
import en from './en';
import cn from './zh-CN';
import ja from './ja'
export default {
    en,
    cn,
    ja
}